export default function () {
  // Если направления не выбраны, или выбрано несколько
  let title = this.$t('rt0822.events.head.title');
  let description = this.$t('rt0822.events.head.description');

  // Если выбрано одно направление
  const directionSlug = this.$route.params.directions;
  if (directionSlug) {
    const direction =
      this.$store.getters['eventsList/GET_DIRECTION_BY_SLUG'](directionSlug);

    title = direction?.eventMetaTitle;
    description = direction?.eventMetaDescription;
  }

  return {
    bodyAttrs: {
      class: 'body--events-list',
    },
    title,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: description,
      },
      {
        hid: 'og:description',
        name: 'og:description',
        property: 'og:description',
        content: description,
      },
      {
        hid: 'og:title',
        name: 'og:title',
        property: 'og:title',
        content: title,
      },
      {
        hid: 'og:site_name',
        name: 'og:site_name',
        property: 'og:site_name',
        content: 'EBAC Online',
      },
      {
        hid: 'og:url',
        name: 'og:url',
        property: 'og:url',
        content: `https://${this.$app.config.current.domain}${this.$route.path}`,
      },
      {
        hid: 'og:locale',
        name: 'og:locale',
        property: 'og:locale',
        content: this.$app?.config?.current?.localeName,
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: `https://${
          this.$store?.state?.host
        }${require(`~/assets/${this.$app?.config?.common?.currentCountry}/svg/ebac-logo.svg`)}`,
      },
      {
        hid: 'og:type',
        name: 'og:type',
        property: 'og:type',
        content: 'website',
      },
    ],
  };
}
